import { render, staticRenderFns } from "./v-text.vue?vue&type=template&id=19fb8466&scoped=true&"
import script from "./v-text.vue?vue&type=script&lang=js&"
export * from "./v-text.vue?vue&type=script&lang=js&"
import style0 from "./v-text.vue?vue&type=style&index=0&lang=less&"
import style1 from "./v-text.vue?vue&type=style&index=1&id=19fb8466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb8466",
  null
  
)

export default component.exports